import React from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import { Stack } from '@mui/material';
import OutputActivationThresholdField, { schema as FieldSchema} from './OutputActivationThresholdField';
import * as Yup from 'yup';

export const schema = Yup.object({
  ht: FieldSchema,
  lt: FieldSchema
});

export const TYPE = 'oas';
export const defaultValue = {
  ht: 0,
  lt: 0,
};

export default function OutputActivationSchmitt({ namespace, ...props }) {
  return (
    <Stack spacing={2} direction='row' alignItems='center'>
      <OutputActivationThresholdField namespace={namespace + '.ht'} label='High Threshold' />
      <OutputActivationThresholdField namespace={namespace + '.lt'} label='Low Threshold' />
    </Stack>
  )
}

OutputActivationSchmitt.propTypes = {
  namespace: propTypes.string,
}
